import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cedd6224"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "deleteGroup"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_6 = { class: "modal-body content" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "rounded-4 overflow-item border-container"
}
const _hoisted_11 = { class: "col-7 break-word" }
const _hoisted_12 = { class: "col-2 text-center" }
const _hoisted_13 = { class: "modal-footer d-flex justify-content-center" }

import messageTemplateServices from '@/services/message-template.services'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { useRoute } from 'vue-router'
import { translate } from '@/languages/i18n'
import { computed, ComputedRef, ref, watchEffect } from 'vue'
import Button from '@/components/button/index.vue'
import { ReplayName } from '@/constants/common.ts'
import { ROOT_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  messageId: String,
  invitationGroup: Boolean,
},
  setup(__props) {

const props = __props

const route = useRoute()


const users = ref([])
const loading = ref<boolean>(false)

const store = useStore()
const isMobile = computed<ComputedRef<boolean>>(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])

watchEffect(async () => {
  if (props.messageId) {
    loading.value = true
    const params = {
      invitation_group: props.invitationGroup,
    }
    try {
      const res = await messageTemplateServices.getMessageReceivers(route.params.id, props.messageId, params)
      if (res.data?.success) {
        users.value = res?.data?.data
      }
      loading.value = false
    } catch (error) {
      loading.value = false

      console.log(error)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_unref(translate)('OE65deliver')) + " " + _toDisplayString(users.value.length) + " " + _toDisplayString(_unref(translate)('OE65user')), 1),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true),
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: user.id,
                    class: _normalizeClass(['d-flex px-4 py-2 ', user.active ? 'bg-secondary' : ''])
                  }, [
                    _createVNode(UserAliasIcon, {
                      userType: user?.user_type
                    }, null, 8, ["userType"]),
                    _createElementVNode("span", {
                      class: _normalizeClass([_unref(isMobile) ? 'me-5' : 'me-2', 'col-3'])
                    }, _toDisplayString(user?.management_no), 3),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(ReplayName)(user?.is_deleted_in_30_days, user?.available, user?.family_name, user?.given_name, user?.user_type)) + _toDisplayString(user?.user_type == 'alumni' && [0, 1].includes(user?.is_deleted_in_30_days) ? `（ ${user?.display_name} ）` : ''), 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(user?.read ? _unref(translate)('OE68read') : ''), 1)
                  ], 2))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(Button, {
          title: _unref(translate)('close'),
          type: 'secondary',
          "data-bs-dismiss": "modal"
        }, null, 8, ["title"])
      ])
    ])
  ]))
}
}

})